module.exports = __webpack_public_path__ + "img/shipin.63f049f5.png";